import { render, staticRenderFns } from "./DatasetModal.vue?vue&type=template&id=78a902be"
import script from "./DatasetModal.vue?vue&type=script&lang=js"
export * from "./DatasetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports